export const CREATE_CUSTOMFIELD_START = "CREATE_CUSTOMFIELD_START";
export const CREATE_CUSTOMFIELD_ERROR = "CREATE_CUSTOMFIELD_ERROR";
export const CREATE_CUSTOMFIELD_SUCCESS = "CREATE_CUSTOMFIELD_SUCCESS";
export const CREATE_CUSTOMFIELD_RESET = "CREATE_CUSTOMFIELD_RESET";

export const UPDATE_CUSTOMFIELD_START = "UPDATE_CUSTOMFIELD_START";
export const UPDATE_CUSTOMFIELD_ERROR = "UPDATE_CUSTOMFIELD_ERROR";
export const UPDATE_CUSTOMFIELD_SUCCESS = "UPDATE_CUSTOMFIELD_SUCCESS";
export const UPDATE_CUSTOMFIELD_RESET = "UPDATE_CUSTOMFIELD_RESET";

export const GETALL_CUSTOMFIELD_START = "GETALL_CUSTOMFIELD_START";
export const GETALL_CUSTOMFIELD_ERROR = "GETALL_CUSTOMFIELD_ERROR";
export const GETALL_CUSTOMFIELD_SUCCESS = "GETALL_CUSTOMFIELD_SUCCESS";
export const GETALL_CUSTOMFIELD_RESET = "GETALL_CUSTOMFIELD_RESET";

export const GETLEADS_CUSTOMFIELD_START = "GETLEADS_CUSTOMFIELD_START";
export const GETLEADS_CUSTOMFIELD_ERROR = "GETLEADS_CUSTOMFIELD_ERROR";
export const GETLEADS_CUSTOMFIELD_SUCCESS = "GETLEADS_CUSTOMFIELD_SUCCESS";
export const GETLEADS_CUSTOMFIELD_RESET = "GETLEADS_CUSTOMFIELD_RESET";

export const GETCUST_CUSTOMFIELD_START = "GETCUST_CUSTOMFIELD_START";
export const GETCUST_CUSTOMFIELD_ERROR = "GETCUST_CUSTOMFIELD_ERROR";
export const GETCUST_CUSTOMFIELD_SUCCESS = "GETCUST_CUSTOMFIELD_SUCCESS";
export const GETCUST_CUSTOMFIELD_RESET = "GETCUST_CUSTOMFIELD_RESET";